module.exports = __webpack_public_path__ + "static/media/hacker.4e301275.png";